<template>
  <div class="home__short-info">
    <p class="home__short-info__paragraph">
      Jadalnia to elegancka i bardzo przyjazna restauracja w Międzylesiu.
      Polecamy nowoczesne dania z kuchni polskiej, podane w nowatorski sposób.
    </p>
    <div class="home__short-info__links">
      <router-link to="/menu">Sprawdź nasze menu</router-link>
      <a href="#contact" v-smooth-scroll>Napisz do nas</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shortInfo'
}
</script>
